import { generateHeader, POSTAPI } from "src/api-setup/api-helper";
import { TRANSACTIONS_PROCESS } from "src/api-setup/api-endpoints";

export const processEventTransactions = async (cookiesData, dispatch, timesheetKeys) => {
  if (!cookiesData || !timesheetKeys || timesheetKeys.length === 0) {
    return { success: false, status: false, error: "Invalid parameters" };
  }
  try {
    const apiHeaders = generateHeader();
    const requestBody = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_timesheet_mstr_key: timesheetKeys,
    };
    const response = await POSTAPI(false, TRANSACTIONS_PROCESS, null, apiHeaders, requestBody, dispatch);
    // On 200 the response interceptor returns the body directly; on error makeApi
    // returns the full axios response (body under `.data`, numeric `.status`).
    const body = typeof response?.status === "number" ? response?.data : response;
    const data = body?.data || {};
    return {
      success: data.success === true,
      count: data.count ?? 0,
      batchKey: data.batchKey ?? null,
      status: body?.status === true,
      error: body?.errors?.msg || null,
    };
  } catch (error) {
    console.error("Error in processEventTransactions:", error);
    return { success: false, status: false, error: error.message };
  }
};
